import { Box, BoxProps, Flex, useTheme } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { hexToRGB } from "utils/colorUtils";

type ScrollableAreaProps = BoxProps;

const ScrollableArea = ({ children, ...rest }: ScrollableAreaProps) => {
  const { colors } = useTheme();
  const [isScrollable, setIsScrollable] = useState(false);
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (containerRef.current) {
      setIsScrollable(
        containerRef.current.scrollHeight > containerRef.current.clientHeight
      );
    }
  }, [children]);

  return (
    <Flex
      direction="column"
      overflowY="scroll"
      align="stretch"
      w="full"
      maxH="full"
      h="full"
      spacing="2px"
      position="relative"
      {...rest}
    >
      <Box overflowY="auto" ref={containerRef}>
        {children}
      </Box>

      {isScrollable && (
        <Box
          position="absolute"
          bottom="0"
          h="8"
          left="0"
          right="0"
          pointerEvents="none"
          zIndex="1"
          bg={`linear-gradient(180deg, ${hexToRGB(
            colors.dark[500],
            0
          )} 0%, ${hexToRGB(colors.dark[500], 1)} 100%)`}
        />
      )}
    </Flex>
  );
};

export default ScrollableArea;
